import React, { useRef } from 'react';
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS } from "../../utils/const/estilos-const";
import cargandoCard from "../../components/cargando-card";
import { obtenerDetalleRespuestaChecklist, obtenerFormularioChecklist, obtenerFormularioPieDePagina, } from "../../api/api-checklist";
import DropdownExportarDetalleChecklist from '../../components/dropdown-exportar-detalle-checklist';
import * as XLSX from 'xlsx-js-style';
import { obtenerInfoEmpresa } from '../../api/gestion-dts/api-rastreo-v4';
import moment from 'moment';
import ComponentDetalleChecklist from '../../components/component-detalle-checklist';
import { obtenerImagenDefaultEmpresa } from '../../api/imagen-empresa';
import { useTranslation } from "react-i18next";
import html2pdf from 'html2pdf.js';

export default function DetalleChecklist() {
    const reportTemplateRef = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [dataChecklist, setDataChecklist] = useState(null);
    const [detalleChecklist, setDetalleChecklist] = useState([]);

    const [infoEmpresa, setInfoEmpresa] = useState({});
    const [urlImagen, setUrlImagen] = useState(null);

    const [infoFormulario, setInfoFormulario] = useState(null);

    // const [infoChecklist, setInfoChecklist] = useState(null);
    const [infoFormularioPiePagina, setInfoFormularioPiePagina] = useState(null);

    const [nombreChecklist, setNombreChecklist] = useState(null);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);

            setDataChecklist(data);

            setNombreChecklist(data.nombreChecklist);

            let objEnviar = {};
            objEnviar.idRespuestaChecklist = data.id;
            objEnviar.idTipoChecklist = data.idTipoChecklist;
            objEnviar.idChecklist = data.idChecklist;
            const detalle = await obtenerDetalleRespuestaChecklist(objEnviar);
            // console.log('detalle');
            // console.log(detalle);

            // objEnviar.id = data.idChecklist;
            // const infoCheck = await obtenerInfoChecklist(objEnviar);
            // console.log('infoCheck');
            // console.log(infoCheck);
            // setInfoChecklist(infoCheck);

            const info = await obtenerInfoEmpresa();
            setInfoEmpresa(info);

            const url = await obtenerImagenDefaultEmpresa();
            setUrlImagen(url);

            setDetalleChecklist(detalle);

            const formularioChecklist = await obtenerFormularioChecklist(objEnviar);
            setInfoFormulario(formularioChecklist);

            const formularioPieDePagina = await obtenerFormularioPieDePagina(objEnviar);
            // console.log('formularioPieDePagina', formularioPieDePagina);
            setInfoFormularioPiePagina(formularioPieDePagina);

            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const obtenerCodigoChecklist = (dataChecklist) => {
        try {
            const codigo = dataChecklist.codigo;
            if (codigo !== null) {
                return (
                    <p>{t('label_codigo')}: {codigo}</p>
                );
            }
            const fechaRegistro = dataChecklist.fechaRegistro;
            const fechaFormateada = moment(fechaRegistro).isValid()
                ? moment(fechaRegistro).format('YYYYMMDDHHmmss')
                : fechaRegistro;
            return (
                <p>{t('label_codigo')}: {fechaFormateada}</p>
            );
        } catch (err) {
            console.log('obtenerCodigoChecklist err');
            console.log(err);
            const fechaFormateada = moment(dataChecklist.fechaRegistro).isValid()
                ? moment(dataChecklist.fechaRegistro).format('YYYYMMDDHHmmss')
                : dataChecklist.fechaRegistro;
            return (
                <p>{t('label_codigo')}: {fechaFormateada}</p>
            );
        }
    };

    const renderdetalleChecklist = () => {
        try {
            // console.log('renderdetalleChecklist');
            // console.log(detalleChecklist);
            // if (detalleChecklist.length > 0) {
            return (
                <>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                        {urlImagen !== null &&
                            <img
                                src={urlImagen}
                                alt="Log Empresa"
                                className='img'
                                style={{
                                    maxWidth: '200px',
                                }}
                                crossOrigin="anonymous"
                            />
                        }
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            {infoEmpresa.NOMBRE}
                        </div>
                        <div style={{
                        }}>
                            <p>{moment(dataChecklist.fechaActualChecklist).isValid() === true ? moment(dataChecklist.fechaActualChecklist).format('YYYY/MM/DD') : ""}</p>
                            <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                                {dataChecklist.nombreChecklist}
                            </p>
                            <p>{dataChecklist.labelVehiculo}</p>
                            {obtenerCodigoChecklist(dataChecklist)}
                        </div>
                    </div>
                    <ComponentDetalleChecklist
                        detalleChecklist={detalleChecklist}
                        infoFormulario={infoFormulario}
                        showFooter={true}
                        formularioPieDePagina={infoFormularioPiePagina}
                    />
                </>
            );
            // }
            // return null;
        } catch (err) {
            console.log('renderdetalleChecklist err');
            console.log(err);
            return null;
        }
    };

    const exportToExcel = async () => {
        try {
            const wb = XLSX.utils.book_new();

            // Static data
            let infoFormularioData = [];
            if (infoFormulario !== null) {
                infoFormularioData = infoFormulario.map(({ label, value }) => ({
                    Pregunta: label,
                    Respuesta: value
                }));
            }

            // Convert static data into worksheet format
            const staticWorksheet = XLSX.utils.json_to_sheet(infoFormularioData, { header: [t("header_pregunta"), t("header_respuesta")] });
            staticWorksheet['!cols'] = [
                { wch: 40 },
                { wch: 60 },
                { wch: 40 },
                { wch: 40 },
            ];
            // Make cell bold
            // const ws = XLSX.utils.json_to_sheet(staticWorksheet);
            staticWorksheet["A1"].s = {
                font: {
                    bold: true,
                }
            };
            staticWorksheet["B1"].s = {
                font: {
                    bold: true,
                }
            };
            // Dynamic data
            const dynamicData = detalleChecklist;
            // Flatten dynamic data
            const dynamicWorksheetData = dynamicData.flatMap((section) =>
                section.preguntas.map((question) => ({
                    Seccion: section.nombreSeccion,
                    Pregunta: question.labelPregunta,
                    OpcionRespuesta: question.labelOpcionRespuesta,
                    Critico: question.critico ? t('label_si') : t('label_no')
                }))
            );

            // Convert dynamic data into worksheet format
            // const dynamicWorksheet = XLSX.utils.json_to_sheet(dynamicWorksheetData, { skipHeader: true });

            // console.log("infoFormularioData", infoFormularioData);
            const index = infoFormularioData.length + 3;

            // Merge the static data and dynamic data into the same sheet
            // First, copy the static data to the sheet
            XLSX.utils.book_append_sheet(wb, staticWorksheet, 'Checklist Data');

            // Now append dynamic data starting right below the static data
            const lastRow = infoFormularioData.length + 2; // Leave a row empty between static and dynamic data
            const range = XLSX.utils.decode_range(staticWorksheet['!ref']);
            range.s.r = lastRow; // Set the starting row for dynamic data
            staticWorksheet['!ref'] = XLSX.utils.encode_range(range); // Update sheet reference

            // Add dynamic data below static data
            XLSX.utils.sheet_add_json(staticWorksheet, dynamicWorksheetData, { origin: `A${lastRow + 1}` });

            // Make header cells bold for dynamic data
            staticWorksheet["A" + index].s = { font: { bold: true } };
            staticWorksheet["B" + index].s = { font: { bold: true } };
            staticWorksheet["C" + index].s = { font: { bold: true } };
            staticWorksheet["D" + index].s = { font: { bold: true } };

            // Write the workbook to a file
            XLSX.writeFile(wb, 'checklist_data.xlsx');
        } catch (err) {
            console.error('exportToExcel error:', err);
        }
    };

    const exportToPdf = () => {
        try {
            const content = reportTemplateRef.current;
            if (!content) return;
            const options = {
                filename: `${nombreChecklist}.pdf`,
                margin: 10,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: false,
                    logging: false,
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                },
            };
            html2pdf().set(options).from(content).save();
        } catch (err) {
            console.error('exportToPdf error:', err);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="m-4">
                    <div className="pt-1 pb-1 pr-2 flex justify-between items-center">
                        <label className="font-bold">
                            {t('titulo_detalle_checklist')}
                        </label>
                        <div className='flex items-center'>
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={handleAtrasClick}
                            >
                                {t('btn_atras')}
                            </button>
                            <DropdownExportarDetalleChecklist
                                exportToExcel={exportToExcel}
                                exportToPdf={exportToPdf}
                            />
                        </div>
                    </div>
                    <hr />
                    <div
                        style={{
                            width: '90%'
                        }}
                    >
                    </div>
                    <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12"
                        ref={reportTemplateRef} id="reportTemplateRef">

                        {renderdetalleChecklist()}

                    </div>
                </div >
            );
        } catch (err) {
            console.log('render err DetalleChecklist');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }


    return render();
};

